var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mark"},[_c('div',{staticClass:"markItem"},[_vm._v("减弱")]),_c('div',{staticClass:"markItem"},[_vm._v("普通")]),_c('div',{staticClass:"markItem"},[_vm._v("加强")]),_c('div',{class:_vm.item.status == '减弱'
        ? 'markIcon'
        : _vm.item.status == '普通'
        ? 'markIcon markIconPh'
        : 'markIcon markIconjq'},[_c('span',[_vm._v(_vm._s(_vm.item.value))]),_c('img',{attrs:{"src":_vm.colorsImg[_vm.lev]}})])])}
var staticRenderFns = []

export { render, staticRenderFns }